import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const KEY = "fiad_cookie_consent";

// Apply the stored/chosen preference to PostHog. Non-essential analytics is opt-out
// by default (see index.html), so we only opt IN when the user explicitly accepts.
function applyConsent(choice) {
  const ph = window.posthog;
  if (!ph || typeof ph.opt_in_capturing !== "function") return;
  try {
    if (choice === "accepted") {
      ph.opt_in_capturing();
      ph.startSessionRecording?.();
    } else {
      ph.stopSessionRecording?.();
      ph.opt_out_capturing();
    }
  } catch (_) {}
}

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(KEY);
    if (saved === "accepted" || saved === "rejected") {
      applyConsent(saved);
    } else {
      setVisible(true);
    }
    const reopen = () => setVisible(true);
    window.addEventListener("fiad:open-cookie-preferences", reopen);
    return () => window.removeEventListener("fiad:open-cookie-preferences", reopen);
  }, []);

  const choose = (choice) => {
    localStorage.setItem(KEY, choice);
    applyConsent(choice);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent"
      className="fixed bottom-0 inset-x-0 z-[100] px-4 pb-4 sm:px-6 sm:pb-6"
    >
      <div className="mx-auto max-w-3xl bg-[#0A0A0A] text-[#F6F3EC] border border-[#C79447]/40 rounded-sm shadow-xl p-5 sm:p-6">
        <div className="flex flex-col sm:flex-row sm:items-center gap-4">
          <p className="text-sm leading-relaxed text-[#D9D4C7] flex-1">
            FIAD uses only essential cookies for sign-in and security. We would also like to
            use optional analytics (product usage &amp; session insights) to improve the
            experience. These stay off until you accept. See our{" "}
            <Link to="/privacy" className="underline hover:text-white" data-testid="cookie-privacy-link">
              Privacy Policy
            </Link>{" "}
            and{" "}
            <Link to="/cookie" className="underline hover:text-white">
              Cookie Notice
            </Link>
            .
          </p>
          <div className="flex items-center gap-3 shrink-0">
            <button
              data-testid="cookie-reject-btn"
              onClick={() => choose("rejected")}
              className="text-sm font-medium px-4 py-2.5 rounded-sm border border-[#525252] text-[#F6F3EC] hover:border-[#F6F3EC] transition-colors"
            >
              Reject non-essential
            </button>
            <button
              data-testid="cookie-accept-btn"
              onClick={() => choose("accepted")}
              className="text-sm font-medium px-5 py-2.5 rounded-sm bg-[#C79447] text-[#0A0A0A] hover:bg-[#d8a961] transition-colors"
            >
              Accept all
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
